//import Vue from 'vue';
import Vue from "vue";
import sessionIdDirective from "../directive/sessionId-directive";
import initService from "./init-service";
import commonService from "./common";

let baseurl = `${process.env.VUE_APP_CONFIG_BASEURL}`;
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let client = `${process.env.VUE_APP_CLIENT}`;

let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': apikey
  }
};

const hssDashboardService = {

  async inventory(start, length, total, sort, filter) {
    filter = encodeURI(filter);
    let params = `hss_getinventory&start=${start}&length=${length}&total=${total}&sort=${sort}&filter=${filter}`;
    //let params = `hss_getinventory&filter=${filter}`;
    return commonService.commonAPI(params, 0, 15);
  },


  //hss_getactivatesettings
  async getsubscribersettings(iccid) {
    iccid = encodeURI(iccid);
    let url = `${baseurl}?method=hss_getactivatesettings&iccid=${iccid}`;
    return Vue.axios.get(url, headers);
  },

  async query(iccid, queryType) {
    iccid = encodeURI(iccid);
    let url = `${baseurl}?method=hss_getdetails&iccid=${iccid}&query=${queryType}&useNameValue=1`;
    return Vue.axios.get(url, headers);
  },

  async activate(data) {
    data = encodeURI(JSON.stringify(data));
    let url = `${baseurl}?method=hss_activate&data=${data}`;
    return Vue.axios.get(url, headers);
  },

  async hss_reset(imsi) {
    // username = encodeURI(username);
    // op = encodeURI(op);
    // value = encodeURI(value);
    let url = `${baseurl}?method=hss_reset&imsi=${imsi}`;
    return Vue.axios.get(url, headers);
  },

  async hss_remove(imsi) {
    let url = `${baseurl}?method=hss_remove&imsi=${imsi}`;
    return Vue.axios.get(url, headers);
  },

  async hss_changespeed(imsi, plan_name) {
    plan_name = encodeURI(plan_name);
    let params = `hss_changespeed&imsi=${imsi}&plan_name=${plan_name}`;
    return commonService.commonAPI(params, 0, 15);
  },

};

export default hssDashboardService;
